import { gql } from '@apollo/client'

export const SETTINGS_QUERY = gql`
	query currentUserSettings{
	  currentUserSettings {
	    defaultDocumentExtension
	    showPlaylistFirst
	    email
	    preferredLanguage
	    syncOnStartup
	    expandDescriptionsByDefault
	    username
	    businessUnits
	    departments
      salesOrganizations
	  }
	}`;

export const SET_PLAYLIST_FIRST_MUTATION = gql`
  mutation changeCurrentUserShowPlaylistFirst($input: Boolean){
    changeCurrentUserShowPlaylistFirst(input: $input)
  }
`;

export const SET_EXPANDED_BY_DEFAULT_MUTATION = gql`
  mutation changeCurrentUserExpandDescriptionsByDefault($input: Boolean){
    changeCurrentUserExpandDescriptionsByDefault(input: $input)
  }
`;

export const SET_SYNC_ON_STARTUP_MUTATION = gql`
  mutation changeCurrentUserSyncOnStartup($input: Boolean){
    changeCurrentUserSyncOnStartup(input: $input)
  }
`;

export const SET_PREFERRED_DEFAULT_FORMAT_MUTATION = gql`
  mutation changeCurrentUserDefaultDocExt($input: String){
    changeCurrentUserDefaultDocExt(input: $input)
  }
`;

export const SET_PREFERRED_LANGUAGE_MUTATION = gql`
  mutation changeCurrentUserPreferredLanguage($input: String){
    changeCurrentUserPreferredLanguage(input: $input)
  }
`;


export const CHANGE_CURRENT_USER_PASSWORD_MUTATION = gql`
  mutation changeCurrentUserPassword($newpassword: String){
  changeCurrentUserPassword(newpassword: $newpassword)
}
`;


